import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/a9d6aff03562300b57162884cb61551b/452a0b34ca5601d37f92054b15f576b4.png" 
              alt="Brite Solutions" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors cursor-pointer ${
                isActive('/') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              Home
            </Link>
            <div className="relative group">
              <button className="font-medium text-gray-700 hover:text-teal-600 transition-colors cursor-pointer flex items-center whitespace-nowrap">
                Services
                <i className="ri-arrow-down-s-line ml-1"></i>
              </button>
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <Link
                  to="/consumer-debt-settlement"
                  className="block px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer rounded-t-lg"
                >
                  <div className="font-semibold">Consumer Debt Settlement</div>
                  <div className="text-sm text-gray-500">Credit cards, personal loans, medical bills</div>
                </Link>
                <Link
                  to="/business-debt-relief"
                  className="block px-6 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors cursor-pointer rounded-b-lg"
                >
                  <div className="font-semibold">Business Debt Relief</div>
                  <div className="text-sm text-gray-500">MCA, business loans, commercial debt</div>
                </Link>
              </div>
            </div>
            <Link
              to="/resources"
              className={`font-medium transition-colors cursor-pointer ${
                isActive('/resources') ? 'text-teal-600' : 'text-gray-700 hover:text-teal-600'
              }`}
            >
              Resources
            </Link>
            <a
              href="tel:+18005551234"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors cursor-pointer flex items-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              (800) 555-1234
            </a>
          </nav>

          {/* CTA Button */}
          <button
            onClick={() => document.querySelector<HTMLElement>('#vapi-widget-floating-button')?.click()}
            className="hidden md:block bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Get Free Consultation
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700 cursor-pointer"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-4">
            <Link
              to="/"
              className={`block font-medium transition-colors cursor-pointer ${
                isActive('/') ? 'text-teal-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <div className="space-y-2">
              <div className="font-medium text-gray-900">Services</div>
              <Link
                to="/consumer-debt-settlement"
                className="block pl-4 text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Consumer Debt Settlement
              </Link>
              <Link
                to="/business-debt-relief"
                className="block pl-4 text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Business Debt Relief
              </Link>
            </div>
            <Link
              to="/resources"
              className={`block font-medium transition-colors cursor-pointer ${
                isActive('/resources') ? 'text-teal-600' : 'text-gray-700'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Resources
            </Link>
            <a
              href="tel:+18005551234"
              className="block font-medium text-gray-700 hover:text-teal-600 transition-colors cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              (800) 555-1234
            </a>
            <button
              onClick={() => {
                document.querySelector<HTMLElement>('#vapi-widget-floating-button')?.click();
                setIsMobileMenuOpen(false);
              }}
              className="w-full bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Free Consultation
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}
